import { lazy } from "react";

const ReportesLayout = lazy(() =>
      import("../../reportes/ReportesLayout.jsx")
);

const Reportes = lazy(() =>
      import("../../reportes/Reportes.jsx")
);

const ReporteLibroVentas = lazy(() =>
      import("../../reportes/ReporteLibroVentas.jsx")
);

const ReporteLibroCompras = lazy(() =>
      import("../../reportes/ReporteLibroCompras.jsx")
);

const ReporteProductosVendidos = lazy(() =>
      import("../../reportes/ReporteProductosVendidos.jsx")
);

const ReporteStock = lazy(() =>
      import("../../reportes/ReporteStock.jsx")
);

const ReporteCuentas = lazy(() =>
      import("../../reportes/ReporteCuentas.jsx")
);

const ReporteProyeccionIVA = lazy(() =>
      import("../../reportes/ReporteProyeccionIVA.jsx")
);

const IndicadoresLayout = lazy(() =>
      import("../../indicadores/IndicadoresLayout.jsx")
);

const IndicadoresStockLayout = lazy(() =>
      import("../../indicadores/IndicadoresStockLayout.jsx")
);

const IndicadoresNegocioLayout = lazy(() =>
      import("../../indicadores/IndicadoresNegocioLayout.jsx")
);

const IndicadoresRentabilidadLayout = lazy(() =>
      import("../../indicadores/IndicadoresRentabilidadLayout.jsx")
);

const reportesRoutes = [
      {
            path: "reportes",
            element: <ReportesLayout />,
            children: [
                  { index: true, element: <Reportes /> },
                  { path: "libro-ventas", element: <ReporteLibroVentas /> },
                  { path: "libro-compras", element: <ReporteLibroCompras /> },
                  { path: "productos-vendidos", element: <ReporteProductosVendidos /> },
                  { path: "stock", element: <ReporteStock /> },
                  { path: "cuentas", element: <ReporteCuentas /> },
                  { path: "proyeccion-iva", element: <ReporteProyeccionIVA /> },
                  { path: "indicadores", element: <IndicadoresLayout /> },
                  { path: "indicadores-stock", element: <IndicadoresStockLayout /> },
                  { path: "indicadores-negocio", element: <IndicadoresNegocioLayout /> },
                  { path: "indicadores-rentabilidad", element: <IndicadoresRentabilidadLayout /> },
            ],
      },
];

export default reportesRoutes;